export default __webpack_public_path__ + "static/media/kitura.d2bc876c.svg";